import React, { useState } from "react";
import { View, Text, TouchableOpacity } from "react-native";

import Colors from "../../Resources/Color";
import Fonts from "../../Resources/Fonts";

import { FontAwesome } from "@expo/vector-icons";
import { Feather } from "@expo/vector-icons";
import { AntDesign } from "@expo/vector-icons";
import { SimpleLineIcons } from "@expo/vector-icons";
import { Ionicons } from "@expo/vector-icons";
import { useScreenDimensions, useDevice } from "../_layout";
import { FontAwesome6 } from "@expo/vector-icons";
import FontAwesome5 from "@expo/vector-icons/FontAwesome5";
import MaterialCommunityIcons from "@expo/vector-icons/MaterialCommunityIcons";

import { useTranslation } from "react-i18next";

const WARNING_EMPTY_VIEW_COLORS = Object.freeze({
  icon: Colors.warningTextColor,
  haloOuter: Colors.warningBackgroundColor,
  haloInner: Colors.warningBackgroundColor,
  haloOuterOpacity: 0.18,
  haloInnerOpacity: 0.28,
  title: Colors.warningTextColor,
  description: Colors.darkgrayColor,
  ctaBackground: Colors.warningTextColor,
});

const DEFAULT_EMPTY_VIEW_COLORS = Object.freeze({
  icon: Colors.bubbleColor,
  haloOuter: Colors.bubbleColor,
  haloInner: Colors.bubbleColor,
  haloOuterOpacity: 0.06,
  haloInnerOpacity: 0.08,
  title: Colors.blackColor,
  description: Colors.grayColor,
  ctaBackground: Colors.bubbleColor,
});

const IconEmptyView = ({
  iconLibrary,
  iconName,
  mainText,
  subText,
  marginTop,
  marginBottom,
  ctaText,
  onCtaPress,
  variant = "default",
}) => {
  const [isCtaHovered, setIsCtaHovered] = useState(false);
  const screenSize = useScreenDimensions();
  const { t } = useTranslation();
  const { isMobile } = useDevice();
  const palette =
    variant === "warning" ? WARNING_EMPTY_VIEW_COLORS : DEFAULT_EMPTY_VIEW_COLORS;
  return (
    <View
      style={{
        width: "100%",
        alignItems: "center",
        flex: 1,
        justifyContent: "center",
        marginTop: marginTop ? marginTop : 0,
        marginBottom: marginBottom ? marginBottom : 0,
        padding: 16,
      }}
    >
      <View
        style={{
          alignItems: "center",
          marginBottom: 20,
          justifyContent: "center",
        }}
      >
        <View
          style={{
            width: 64,
            height: 64,
            borderRadius: 32,
            backgroundColor: palette.haloOuter,
            opacity: palette.haloOuterOpacity,
            position: "absolute",
          }}
        />
        <View
          style={{
            width: 48,
            height: 48,
            borderRadius: 24,
            backgroundColor: palette.haloInner,
            opacity: palette.haloInnerOpacity,
            justifyContent: "center",
            alignItems: "center",
            alignSelf: "center",
            position: "absolute",
          }}
        />
        <View
          style={{
            width: 48,
            height: 48,
            borderRadius: 24,
            alignItems: "center",
            justifyContent: "center",
            alignSelf: "center",
            position: "absolute",
          }}
        >
          {iconLibrary === "Ionicons" ? (
            <Ionicons name={iconName} size={24} color={palette.icon} />
          ) : iconLibrary === "FontAwesome5" ? (
            <FontAwesome5 name="dumbbell" size={24} color={palette.icon} />
          ) : iconLibrary === "FontAwesome6" ? (
            <FontAwesome6 name={iconName} size={24} color={palette.icon} />
          ) : iconLibrary === "MaterialCommunityIcons" ? (
            <MaterialCommunityIcons
              name={iconName ?? "magnify-plus-outline"}
              size={34}
              color={palette.icon}
            />
          ) : (
            <SimpleLineIcons name="magnifier-add" size={24} color={palette.icon} />
          )}
        </View>
      </View>
      <Text
        style={[
          screenSize === "small" ? Fonts.medium16 : Fonts.medium16,
          {
            textAlign: "center",
            color: palette.title,
            marginTop: 32,
            fontSize: 15,
          },
        ]}
      >
        {t(mainText)}
      </Text>
      <Text
        style={[
          screenSize === "small" ? Fonts.regular14 : Fonts.regular14,
          {
            textAlign: "center",
            color: palette.description,
            marginTop: 8,
            maxWidth: 380,
            fontSize: 14,
          },
        ]}
      >
        {t(subText)}
      </Text>
      {ctaText && onCtaPress && (
        <TouchableOpacity
          onPress={onCtaPress}
          onMouseEnter={() => !isMobile && setIsCtaHovered(true)}
          onMouseLeave={() => setIsCtaHovered(false)}
          style={{
            marginTop: 24,
            backgroundColor: palette.ctaBackground,
            paddingVertical: 10,
            paddingHorizontal: 16,
            borderRadius: 12,
            alignItems: "center",
            justifyContent: "center",
            opacity: isCtaHovered ? 0.6 : 1,
          }}
        >
          <Text
            style={[
              {
                fontSize: 14,
                color: Colors.whiteColor,
              },
            ]}
          >
            {t(ctaText)}
          </Text>
        </TouchableOpacity>
      )}
    </View>
  );
};
export default IconEmptyView;
